import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../../helpers'
import { ProspectProviderSnapshot } from '../../models/Outreach/types'

export function useProspectProviderSnapshot(prospectId: number | null) {
    return useQuery<ProspectProviderSnapshot>({
        queryKey: ['prospect-provider-snapshot', prospectId],
        queryFn: async () => {
            const res = await axiosInstance.get(
                '/outreach/apartment-prospects/provider-snapshot/',
                { params: { prospect_id: prospectId } },
            )
            return res.data
        },
        enabled: prospectId != null,
        retry: false,
    })
}
